import { styles } from '../../../../utilities'

export default () => {
  return {
    default: {
      count: {
        whiteSpace: 'pre-wrap',
      },
    },
    hidden: styles.visuallyHidden,
  } as const
}
